import getFirstSubdomain from '../../../shared-functions/DomainsplitFunction';
import getToken from '../../helpers';

/**
 * 
 * Default headers for auth
 * @returns
 */
const defaultHeaders = () => {
  const accessToken = getToken();
  const headers: HeadersInit = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  const domain = getFirstSubdomain() || '';
  const blocked = ['facility-dev', 'facility-test', 'facility', 'localhost', 'partner-dev', 'partner-test', 'partner'];

  if (domain && !blocked.some(d => domain.includes(d))) {
    headers.domain = domain;
  }

  return Object.keys(headers).length > 0 ? headers : null;
};

export default defaultHeaders;
